import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=a54b054c&scoped=true"
import script from "./Discussions.vue?vue&type=script&lang=js"
export * from "./Discussions.vue?vue&type=script&lang=js"
import style0 from "./Discussions.vue?vue&type=style&index=0&id=a54b054c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54b054c",
  null
  
)

export default component.exports